import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import {
  SCORE_BADGE_VARIANT,
  type InsightScore,
} from "../../entities/insights";

/*
 * The 🟢/🟡/🔴 severity badge.
 *
 * Selects among the semantic Badge variants rather than passing colour classes
 * per call site — the house rule is to extend the primitive once, so a palette
 * change lands everywhere and dark mode keeps working.
 */

interface ScoreBadgeProps {
  score: InsightScore;
  /** Show only the dot, for dense rows where the label would crowd the title. */
  compact?: boolean;
}

export default function ScoreBadge({ score, compact = false }: ScoreBadgeProps) {
  const { t } = useTranslation();
  const variant = SCORE_BADGE_VARIANT[score] ?? "secondary";
  const label = t(`insights.score.${score}`, score);

  return (
    <Badge variant={variant} aria-label={label} title={label}>
      {compact ? <span aria-hidden="true">●</span> : label}
    </Badge>
  );
}
